import React, { PropsWithChildren } from "react";
import PaymentFilter from "./PaymentFilter";
import PaymentTable from "./PaymentTable";
import { PaymentProvider } from "../../providers/PaymentProvider";
import { withUIProtection } from "../../hoc/withUIProtection";

type Props = PropsWithChildren & {
  asContainer?: boolean;
};


const Payment = ({ children, asContainer = true, ...rest }: Props) => {
  return (
    <PaymentProvider {...rest}>
      <div data-name="payment">{children}</div>
    </PaymentProvider>
  );
};

// Apply UI protection to the subcomponents
const ProtectedPaymentFilter = withUIProtection(PaymentFilter);
const ProtectedPaymentTable = withUIProtection(PaymentTable);

// Attach the protected subcomponents to the ProtectedPayment component
Payment.PaymentFilter = ProtectedPaymentFilter;
Payment.PaymentTable = ProtectedPaymentTable;

export { Payment };

// Export individual protected components
export {
  ProtectedPaymentTable as PaymentTable,
  ProtectedPaymentFilter as PaymentFilter,
};
